"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodeBeet = exports.ErrorCode = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NoValidSignerPresent"] = 0] = "NoValidSignerPresent";
    ErrorCode[ErrorCode["StringIsTooLong"] = 1] = "StringIsTooLong";
    ErrorCode[ErrorCode["NameIsTooLong"] = 2] = "NameIsTooLong";
    ErrorCode[ErrorCode["DescriptionIsTooLong"] = 3] = "DescriptionIsTooLong";
    ErrorCode[ErrorCode["SupplyIsGtThanAvailable"] = 4] = "SupplyIsGtThanAvailable";
    ErrorCode[ErrorCode["SupplyIsNotProvided"] = 5] = "SupplyIsNotProvided";
    ErrorCode[ErrorCode["DerivedKeyInvalid"] = 6] = "DerivedKeyInvalid";
    ErrorCode[ErrorCode["SellingResourceOwnerInvalid"] = 7] = "SellingResourceOwnerInvalid";
    ErrorCode[ErrorCode["PublicKeyMismatch"] = 8] = "PublicKeyMismatch";
    ErrorCode[ErrorCode["PiecesInOneWalletIsTooMuch"] = 9] = "PiecesInOneWalletIsTooMuch";
    ErrorCode[ErrorCode["StartDateIsInPast"] = 10] = "StartDateIsInPast";
    ErrorCode[ErrorCode["EndDateIsEarlierThanBeginDate"] = 11] = "EndDateIsEarlierThanBeginDate";
    ErrorCode[ErrorCode["IncorrectOwner"] = 12] = "IncorrectOwner";
    ErrorCode[ErrorCode["MarketIsNotStarted"] = 13] = "MarketIsNotStarted";
    ErrorCode[ErrorCode["MarketIsEnded"] = 14] = "MarketIsEnded";
    ErrorCode[ErrorCode["UserReachBuyLimit"] = 15] = "UserReachBuyLimit";
    ErrorCode[ErrorCode["MathOverflow"] = 16] = "MathOverflow";
    ErrorCode[ErrorCode["SupplyIsGtThanMaxSupply"] = 17] = "SupplyIsGtThanMaxSupply";
    ErrorCode[ErrorCode["MarketDurationIsNotUnlimited"] = 18] = "MarketDurationIsNotUnlimited";
    ErrorCode[ErrorCode["MarketIsSuspended"] = 19] = "MarketIsSuspended";
    ErrorCode[ErrorCode["MarketIsImmutable"] = 20] = "MarketIsImmutable";
    ErrorCode[ErrorCode["MarketInInvalidState"] = 21] = "MarketInInvalidState";
    ErrorCode[ErrorCode["PriceIsZero"] = 22] = "PriceIsZero";
    ErrorCode[ErrorCode["FunderIsInvalid"] = 23] = "FunderIsInvalid";
    ErrorCode[ErrorCode["PayoutTicketExists"] = 24] = "PayoutTicketExists";
    ErrorCode[ErrorCode["InvalidFunderDestination"] = 25] = "InvalidFunderDestination";
    ErrorCode[ErrorCode["TreasuryIsNotEmpty"] = 26] = "TreasuryIsNotEmpty";
    ErrorCode[ErrorCode["SellingResourceInInvalidState"] = 27] = "SellingResourceInInvalidState";
    ErrorCode[ErrorCode["MetadataCreatorsIsEmpty"] = 28] = "MetadataCreatorsIsEmpty";
    ErrorCode[ErrorCode["UserWalletMustMatchUserTokenAccount"] = 29] = "UserWalletMustMatchUserTokenAccount";
    ErrorCode[ErrorCode["MetadataShouldBeMutable"] = 30] = "MetadataShouldBeMutable";
    ErrorCode[ErrorCode["PrimarySaleIsNotAllowed"] = 31] = "PrimarySaleIsNotAllowed";
    ErrorCode[ErrorCode["CreatorsIsGtThanAvailable"] = 32] = "CreatorsIsGtThanAvailable";
    ErrorCode[ErrorCode["CreatorsIsEmpty"] = 33] = "CreatorsIsEmpty";
    ErrorCode[ErrorCode["MarketOwnerDoesntHaveShares"] = 34] = "MarketOwnerDoesntHaveShares";
    ErrorCode[ErrorCode["PrimaryMetadataCreatorsNotProvided"] = 35] = "PrimaryMetadataCreatorsNotProvided";
    ErrorCode[ErrorCode["GatingTokenMissing"] = 36] = "GatingTokenMissing";
    ErrorCode[ErrorCode["InvalidOwnerForGatingToken"] = 37] = "InvalidOwnerForGatingToken";
    ErrorCode[ErrorCode["WrongGatingMetadataAccount"] = 38] = "WrongGatingMetadataAccount";
    ErrorCode[ErrorCode["WrongOwnerInTokenGatingAcc"] = 39] = "WrongOwnerInTokenGatingAcc";
    ErrorCode[ErrorCode["WrongGatingDate"] = 40] = "WrongGatingDate";
    ErrorCode[ErrorCode["CollectionMintMissing"] = 41] = "CollectionMintMissing";
    ErrorCode[ErrorCode["WrongCollectionMintKey"] = 42] = "WrongCollectionMintKey";
    ErrorCode[ErrorCode["WrongGatingToken"] = 43] = "WrongGatingToken";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
exports.errorCodeBeet = beet.fixedScalarEnum(ErrorCode);
//# sourceMappingURL=ErrorCode.js.map